export const sensorState = {
  0: "working",
  1: "battery_empty",
  2: "maintenace_needed",
  3: "not_sending",
  4: "unknown",
};

export function haveSame18Prefix(tuis) {
  if (!Array.isArray(tuis) || tuis.length === 0) return false;
  const prefix = tuis[0].slice(0, 18);
  return tuis.every((t) => t.startsWith(prefix)) ? prefix : false;
}
